import deBounce from 'lodash.debounce'

document.addEventListener('DOMContentLoaded', function () {
    let mapContainers;
    function checkLatLongRange(lat, lon) {
        // continental USA
        const LAT_MIN = 24.52;
        const LAT_MAX = 49.38;
        const LON_MIN = -124.73;
        const LON_MAX = -66.95;
        if (lat >= LAT_MIN && lat <= LAT_MAX && lon >= LON_MIN && lon <= LON_MAX) {
            return true;
        }
        return false;
    }

    function loadD3Script(callback) {
        if (typeof window.d3 !== 'undefined') {
            callback();
        } else {
            const script = document.createElement('script');
            script.src = '/js/d3.v7.min.js';
            script.async = true;
            script.onload = () => {
                if (typeof window.d3 !== 'undefined') {
                    callback();
                } else {
                    console.error('Failed to load D3.js');
                }
            };
            script.onerror = () => {
                console.error('Error loading D3.js');
            };
            document.head.appendChild(script);
        }
    }

    function initializeMaps() {
        mapContainers.forEach((container, index) => {
            const mapElement = container.querySelector('.map-with-pin__container');
            if (!mapElement) {
                console.warn(`Map container .map-with-pin__container not found for map index ${index}.`);
                return;
            }

            const dataset = container.dataset;
            const pinLat = parseFloat(dataset.pinLat);
            const pinLong = parseFloat(dataset.pinLong);
            const pinTitle = dataset.pinTitle || "Map Pin";
            mapElement.style.backgroundImage = `url('${dataset.mapImg}')`;

            if (!isNaN(pinLat) && !isNaN(pinLong)) {
                if (checkLatLongRange(pinLat, pinLong)) {
                    setTimeout(() => {
                        setMapPin(container, mapElement, pinLat, pinLong, pinTitle, dataset.pinImg,
                            {
                                north: parseFloat(dataset.north),
                                south: parseFloat(dataset.south),
                                east: parseFloat(dataset.east),
                                west: parseFloat(dataset.west)
                            },
                            {
                                rotationLong: parseFloat(dataset.rotationLong),
                                rotationLat: parseFloat(dataset.rotationLat),
                                parallelLow: parseFloat(dataset.parallelLow),
                                parallelHigh: parseFloat(dataset.parallelHigh)
                            }
                        );
                    }, 0);
                }
            } else {
                console.warn(`Invalid latitude (${pinLat}) or longitude (${pinLong}) for pin: "${pinTitle}" in dataset. Pin not placed.`);
            }
        });
    }

    function setMapPin(container, mapElement, latitude, longitude, title, pinImg, bounds, projectionParams) {
        if (isNaN(latitude) || isNaN(longitude)) {
            console.warn(`Invalid latitude (${latitude}) or longitude (${longitude}) for pin: "${title}". Pin not added.`);
            return;
        }
        if (isNaN(bounds.north) || isNaN(bounds.south) || isNaN(bounds.east) || isNaN(bounds.west)) {
            console.warn(`Invalid map bounds for pin: "${title}". Pin not added.`);
            return;
        }
        if (isNaN(projectionParams.rotationLong) || isNaN(projectionParams.rotationLat) || isNaN(projectionParams.parallelLow) || isNaN(projectionParams.parallelHigh)) {
            console.warn(`Invalid projection parameters for pin: "${title}". Pin not added.`);
            return;
        }

        const mapWidth = mapElement.offsetWidth;
        const mapHeight = mapElement.offsetHeight;

        if (mapWidth === 0 || mapHeight === 0) {
            console.warn(`Map container for "${title}" has zero width or height. Cannot place pin accurately. Retrying might help if layout is slow.`);
            return;
        }

        const boundingBox = {
            type: "Feature",
            geometry: {
                type: "Polygon",
                coordinates: [[
                    [bounds.west, bounds.north],
                    [bounds.east, bounds.north],
                    [bounds.east, bounds.south],
                    [bounds.west, bounds.south],
                    [bounds.west, bounds.north]
                ]]
            }
        };

        const projectedPoint = d3.geoAlbers()
            .rotate([projectionParams.rotationLong, projectionParams.rotationLat, 0])
            .parallels([projectionParams.parallelLow, projectionParams.parallelHigh])
            .fitExtent([[0, 0], [mapWidth, mapHeight]], boundingBox)
            ([longitude, latitude]);

        if (!projectedPoint || isNaN(projectedPoint[0]) || isNaN(projectedPoint[1])) {
            console.warn(`Failed to project coordinates [${longitude}, ${latitude}] for pin: "${title}". Pin might be outside the defined bounds or projection failed.`);
            return;
        }

        const existingPin = mapElement.querySelector('.map-with-pin__marker');
        if (existingPin) {
            existingPin.remove();
        }

        const pin = document.createElement('div');
        pin.className = 'map-with-pin__marker';
        pin.title = title;
        pin.style.position = 'absolute';
        pin.style.left = `${(projectedPoint[0] / mapWidth) * 100}%`;
        pin.style.top = `${(projectedPoint[1] / mapHeight) * 100}%`;

        const img = document.createElement('img');
        img.src = pinImg || '/images/default-map-pin.svg';
        img.alt = title || 'Map Pin';

        pin.appendChild(img);
        mapElement.appendChild(pin);
    }

    function setupMaps() {
        mapContainers = document.querySelectorAll('.map-with-pin');

        if (!mapContainers || mapContainers.length === 0) {
            return false; //nothing to do
        }

        loadD3Script(initializeMaps);
    }

    /* run on page load */
    setupMaps();
    const setupMapsDebounced = deBounce(setupMaps, 100);

    /* run on dynamically added elements */
    const dynamicMapObserver = new MutationObserver((mutationsList) => {
        let needsSetup = false;
        for (const mutation of mutationsList) {
            if (mutation.type === 'childList') {
                for (const node of mutation.addedNodes) {
                    if (node.nodeType === Node.ELEMENT_NODE) {
                        if (node.matches('.map-with-pin') || (typeof node.querySelector === 'function' && node.querySelector('.map-with-pin'))) {
                            needsSetup = true;
                            break; //found relevant addition, no need to check further in this record
                        }
                    }
                }
            }
            if (needsSetup) {
                break; //no need to keep checking
            }
        }
        if (needsSetup) {
            setupMapsDebounced();
        }
    });
    dynamicMapObserver.observe(document.documentElement, { childList: true, subtree: true });
});
